// extracted by mini-css-extract-plugin
module.exports = {"modalTitle":"modalTitle--Wnm8T"};